import React from 'react';
import { StyledCell } from '../Table.style';

export const SourceCell = ({ source = '' }) => {
  return <StyledCell>{source?.toUpperCase()}</StyledCell>;
};
